import { useQuery } from '@tanstack/react-query';
import { marketsApi } from '@/api/endpoints';

export const MARKETS_QUERY_KEY = ['markets'] as const;

/**
 * Fetch available betting markets from the odds engine.
 *
 * Polls every 20 s while a tab is visible, and again on focus. The server
 * refreshes racing quotes every 15 s and replaces the quote token whenever
 * the price moves (0036), so a board left alone for a minute is a board whose
 * tokens the server will refuse. The slip re-resolves its held selection on
 * every refetch (BetSlipProvider), which is what turns "The price has changed"
 * from a dead end into a price that ticks in front of the customer.
 */
export function useMarkets() {
  return useQuery({
    queryKey: MARKETS_QUERY_KEY,
    queryFn: marketsApi.list,
    staleTime: 15_000,
    refetchInterval: 20_000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
    // GET /markets returns a bare Market[] per the OpenAPI contract —
    // there is no { markets } wrapper (fixed 2026-06-11).
    select: (data) => data,
  });
}
